import React from 'react';
import { Label } from 'semantic-ui-react';

const Tag = (props) => props.show && <Label tag size='small' content={props.title} color={props.color} />;

export default Tag;



// WEBPACK FOOTER //
// ./src/private/admin/components/EventStatus/Tag/index.js